import { useModals } from "@mantine/modals";
import { createContext, FC, useState } from "react";
import { ModalId } from "src/utils/constants";

export type CatalogModalContextData = {
  isOpenCatalog: boolean;
  setisOpenCatalog: React.Dispatch<React.SetStateAction<boolean>>;
  handleCatalogModal: () => void;
  handleCloseCatalogModal: () => void;
  sortRevenue: string;
  setSortRevenue: (e: string) => void;
};
export const CatalogModalContext = createContext<CatalogModalContextData>(
  {} as CatalogModalContextData
);

interface Props {
  children: React.ReactNode;
}

const CatalogModalProvider: FC<Props> = ({ children }) => {
  const modals = useModals();
  const [isOpenCatalog, setisOpenCatalog] = useState(false);
  const [sortRevenue, setSortRevenue] = useState("");

  const handleCatalogModal = () => {
    if (isOpenCatalog) {
      setisOpenCatalog(false);
      modals.closeModal(ModalId.CatalogModalId);
    } else {
      setisOpenCatalog(true);
    }
  };

  const handleCloseCatalogModal = () => {
    if (isOpenCatalog) {
      setisOpenCatalog(false);
      modals.closeModal(ModalId.CatalogModalId);
    }
  };

  return (
    <CatalogModalContext.Provider
      value={{
        isOpenCatalog,
        setisOpenCatalog,
        handleCatalogModal,
        handleCloseCatalogModal,
        setSortRevenue,
        sortRevenue,
      }}
    >
      {children}
    </CatalogModalContext.Provider>
  );
};

export default CatalogModalProvider;
